import { useI18n } from "@baton/i18n";
import { Button, Dialog } from "@baton/ui";
import { useRuntime } from "../../app/RuntimeProvider.tsx";
import { useRestoredAt } from "./restoreStore.ts";

/**
 * FR-015-155, `spec.md` US26 scenario 6: after the discard the blocking notice names the restore
 * time and offers Reload. It cannot be dismissed, so no write happens behind it.
 */
export function RestoreNotice() {
  const { t, format } = useI18n();
  const runtime = useRuntime();
  const restoredAt = useRestoredAt(runtime);
  if (restoredAt === null) return null;
  return (
    <Dialog
      open
      onOpenChange={() => undefined}
      dismissible={false}
      size="sm"
      title={t("shell.restore.title")}
      footer={
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("shell.restore.reload")}
        </Button>
      }
    >
      <p>{t("shell.restore.body", { time: format.date(new Date(restoredAt), runtime.clock.now(), { time: true }) })}</p>
    </Dialog>
  );
}
